import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap } from 'lucide-react';
export function PriceBlock() {
  return <section id="price-block" className="py-24 bg-navy text-cream relative overflow-hidden" data-id="element-76">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber/10 via-navy to-navy" data-id="element-77"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-79">
          <h2 className="text-3xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-80">
            Recupera tu vida y el sueño de tu bebé por menos de lo que cuesta
            una cena fuera.
          </h2>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto mt-12" data-id="element-81">
            <p className="text-xl text-cream/70 mb-4 line-through decoration-rose/50 decoration-2" data-id="element-82">
              Olvida las consultorías de sueño de $300 dólares.
            </p>

            <div className="mb-8" data-id="element-83">
              <span className="text-lg text-cream/90 block mb-2" data-id="element-84">
                Consigue el Blueprint "Dulces Sueños" por solo
              </span>
              <div className="flex items-start justify-center" data-id="element-85">
                <span className="text-3xl font-medium text-amber mt-2" data-id="element-86">$</span>
                <span className="text-7xl md:text-8xl font-serif font-bold text-amber" data-id="element-87">
                  6.36
                </span>
                <span className="text-xl text-amber mt-10 ml-2" data-id="element-88">USD</span>
              </div>
            </div>

            <motion.a href="https://estadovittal.com//cart/48110257242347:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-amber hover:bg-amber-hover text-navy font-bold text-lg md:text-xl py-5 px-8 rounded-full shadow-[0_0_40px_rgba(212,165,116,0.3)] transition-all duration-300 mb-6 text-center" data-id="element-89">
              QUIERO RECUPERAR MIS NOCHES AHORA
            </motion.a>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-8 text-sm text-cream/60" data-id="element-90">
              <div className="flex items-center" data-id="element-91">
                <Zap className="w-4 h-4 mr-2 text-amber" data-id="element-92" />
                Acceso instantáneo después del pago
              </div>
              <div className="flex items-center" data-id="element-93">
                <Lock className="w-4 h-4 mr-2 text-amber" data-id="element-94" />
                Pago 100% seguro
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}